import * as M from "./style"
import { useSelector } from "react-redux"
import { hideModal, isModalActive } from "utils/modal"
import BaseModal from "../../base"
import TppDeleteVote from "components/parts/mail/tppDeleteVote"

const TppDeleteVoteModal = () => {

    const show = isModalActive(useSelector((state: any) => state.data.modalStates), "tppDeleteVote")

    return (
        <M.Modal>
            <BaseModal
                header={false}
                hide={() => hideModal("tppDeleteVote")}
                show={show}
            >
                <TppDeleteVote />
            </BaseModal>
        </M.Modal>
    )

}

export default TppDeleteVoteModal